import clsx from 'clsx';
import { useSelectContext } from '../Select/SelectContext';
import { useEffect } from 'react';

interface OptionProps<T> extends BaseProps {
  value: T;
}

export function Option<T>({ children, value }: OptionProps<T>) {
  const {
    color,
    onChange,
    setSelectedText,
    value: contextValue,
  } = useSelectContext();
  const classes = useStyles();

  useEffect(() => {
    if (contextValue === value) {
      setSelectedText(children);
    }
  }, [contextValue]);

  return (
    <li
      className={clsx(classes.base, classes[color], {
        [classes.active[color]]: contextValue === value,
      })}
      onClick={() => onChange(value)}
    >
      {children}
    </li>
  );
}

const useStyles = () => ({
  active: {
    primary: 'bg-primary/50',
    secondary: 'bg-secondary/50',
    sand: 'bg-sand/50',
  },
  base: 'cursor-pointer p-2',
  primary: 'hover:bg-primary',
  secondary: 'hover:bg-secondary',
  sand: 'hover:bg-sand',
});
